export function formatFullName(firstname: string, lastname: string): string {
  return [firstname.trim(), lastname.trim()].filter(Boolean).join(' ');
}
